export const TIMER_VOL_LABEL = "Timer Volume";
export const TIMER_SOUND_LABEL = "Timer Sound";
export const AUTO_TRANSITION_TIMER_LABEL = "Auto-transition Timer";
export const HIDE_POMODORO_COUNT_LABEL = "Hide Pomodoro Count";
export const SAVE_TIMER_SETTINGS_BUTTON_LABEL = "Save";
export const PRO_ALARM_CTA_TOOLTIP_LABEL = "Upgrade to access all alarm sounds!";
export const TIMER_DURATION_MINS_MIN_VALUE = 1;
export const TIMER_DURATION_MINS_MAX_VALUE = 360;
export const POMODORO_LABEL = "Pomodoro";
export const SHORT_BREAK_LABEL = "Short Break";
export const LONG_BREAK_LABEL = "Long Break";
export const SHORT_BREAK_TARGET = 3;
export const START_TIMER_LABEL = "Start";
export const PAUSE_TIMER_LABEL = "Pause";
export const STOP_TIMER_LABEL = "Stop";
export const LIFEAT_SPACES_DOC_TITLE = "LifeAt Spaces";
export const TIMER_DOC_TITLE_SUFFIX = " | LifeAt";
export const POMODORO_TIME_MIN = 20;
export const SHORT_BREAK_TIME_MIN = 5;
export const LONG_BREAK_TIME_MIN = 15;
export const PERSONAL_TIMER_LABEL = "Personal";
export const GROUP_TIMER_LABEL = "Group";
export const TASK_TIMER_LABEL = "Task Countdown";
export const COUNTDOWN_TIMER_BUFFER_MS = 250;
export const DEFAULT_TASK_TIMER_MINUTES = 30;
